var map = {
	"./005.jpg": 5926,
	"./010.jpg": 3360,
	"./011.jpg": 8925,
	"./015.jpg": 1665,
	"./020.jpg": 4097,
	"./025.jpg": 2576,
	"./030.jpg": 3562,
	"./035.jpg": 9003,
	"./040.jpg": 8427,
	"./045.jpg": 3930,
	"./050.jpg": 6252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5580;